import { createContext, useContext } from 'react';

import { ReportAttachment } from '../report-types';

type Report = {
  referralSessionId: string;
  referralId: string;
  completedAt?: string;
  updatedAt: string;
  service: string;
  status: string;
};

type ReportContext = {
  path: string;
  navigateToPath: (path: string) => void;
  exportPdf: () => void;
  downloadAttachment: (attachment: ReportAttachment) => void;
  reports: Report[];
  id: string;
};
const reportContext = createContext<ReportContext>({
  downloadAttachment: () => undefined,
  exportPdf: () => undefined,
  id: '',
  navigateToPath: () => undefined,
  path: '',
  reports: [],
});

const useReportContext = () => useContext(reportContext);

const ReportContextProvider = reportContext.Provider;

export type { Report, ReportContext };

export { reportContext, ReportContextProvider, useReportContext };
